const config = {devicesType: "web player",
    clientName: "VCNET",
    portalId: 1,
    vendorId: 1,
    theme: {}, // option, nastavení tématu
    avatarImages: [
        "/assets/profile-images/i1.png",
        "/assets/profile-images/i2.png",
        "/assets/profile-images/i3.png",
        "/assets/profile-images/i4.png",
        "/assets/profile-images/i5.png",
        "/assets/profile-images/i6.png",
        "/assets/profile-images/i7.png",
        "/assets/profile-images/i8.png",
        "/assets/profile-images/i9.png",
    ], // option, cesty k předvolenými avatar obrázky
    mwUrl: "https://mw.vcnet.com.br", // require, cesta na middleware (https://mw.cico.tv/public)
    smsUrl: "https://sms.vcnet.com.br",
    languages: [ "en", "pt" ],
    errorReloadTime: 1000 * 10, // every ten second we try remove errors
}

exports.config = config;